/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import 'views/molecules/modal/newsmodal.scss';
import EbisCheckbox from 'views/atoms/checkbox/EbisCheckbox';

import moment from 'moment';
import {
  getGMT9ISOString,
  handleStorageTrackingData,
  renderNotificationLabel,
} from 'domain/notifications/Services';
import { getUser } from 'store/auth/selectors';
import { shallowEqual, useSelector } from 'react-redux';
import { NOTIFICATION_TYPE } from 'domain/notifications/consts';

const NewsModal = ({
  show,
  onHide,
  newsData,
  handleConfirm,
  showCheckbox,
  notRead,
}) => {
  const isLoginState = localStorage.getItem('after_login_state');

  const { userId, account } = useSelector(getUser, shallowEqual);

  const [isChecked, toggleCheck] = useState(false);
  const [modalStartTime, setModalStartTime] = useState(null);

  const localStorageKey = `tracking_notifications.${account.accountId}.${userId}`;

  const modalHeader = () => (
    <div className="d-flex flex-column align-items-start">
      <div className="d-flex align-items-center news-modal-date-wrapper">
        <span className="news-modal-date">
          {moment(newsData.date_from).format('YYYY/MM/DD')}
        </span>
        {renderNotificationLabel(newsData.display_notification_type, true)}
      </div>
      <div className="news-modal__title">{newsData.title}</div>
    </div>
  );

  const handleStorageLocal = useCallback(() => {
    const dataStorage = handleStorageTrackingData({
      action: 'modal_click',
      accountId: account.accountId,
      userId,
      openTimestamp: modalStartTime,
      closeTimestamp: getGMT9ISOString(),
      modalId: newsData.id,
      modalType:
        NOTIFICATION_TYPE[
          `NOTIFICATION_TYPE_${newsData.display_notification_type}`
        ],
      auto:
        newsData.display_notification_type <= 4 &&
        isLoginState === 'is_not_after_login',
      date: getGMT9ISOString(),
    });

    const trackingNotificationsRaw = localStorage.getItem(localStorageKey);
    const trackingNotifications = trackingNotificationsRaw
      ? JSON.parse(trackingNotificationsRaw)
      : [];

    trackingNotifications.push(dataStorage);
    localStorage.setItem(
      localStorageKey,
      JSON.stringify(trackingNotifications)
    );
  }, [
    account.accountId,
    userId,
    modalStartTime,
    newsData.id,
    newsData.display_notification_type,
    isLoginState,
  ]);

  const handleOkBtn = () => {
    const isUpdateRead = isChecked || !showCheckbox;
    if (notRead) handleConfirm(newsData.id, isUpdateRead);

    handleStorageLocal();

    toggleCheck(() => false);
    onHide();
  };

  const handleCheckedButton = useCallback(() => {
    toggleCheck(!isChecked);
  }, [isChecked]);

  // Track when modal is shown
  useEffect(() => {
    if (show) {
      setModalStartTime(getGMT9ISOString());
    }
  }, [show]);

  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={onHide}
      centered
      size="w800"
      dialogClassName="news-modal"
    >
      <Modal.Header bsPrefix="news-modal__header">
        <Modal.Title as={modalHeader} />
      </Modal.Header>
      <Modal.Body bsPrefix="news-modal__body">
        <p dangerouslySetInnerHTML={{ __html: newsData.detail }} />
      </Modal.Body>
      <Modal.Footer>
        {showCheckbox && (
          <div className="mr-auto">
            <EbisCheckbox
              text="次回以降このモーダルを表示しない"
              name="temp"
              checked={isChecked}
              changeSelectBoxValue={handleCheckedButton}
              disabled={false}
            />
          </div>
        )}
        <Button
          onClick={handleOkBtn}
          variant="secondary"
          className="news-modal-button"
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

NewsModal.defaultProps = {
  show: false,
  onHide: () => {},
};

NewsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  newsData: PropTypes.object.isRequired,
  showCheckbox: PropTypes.bool.isRequired,
  notRead: PropTypes.bool.isRequired,
};

export default React.memo(NewsModal);
